import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { Controller } from "react-hook-form";
import React from 'react';
import Error from '../Error';
import isEmail from 'validator/lib/isEmail';
import { looksLikeEmail } from '@toolz/looks-like-email';
import { bogusCheck } from '../../utils/ValChecker';

export default function NameInfo({ control, watch, errors }) {

    const selectedTitle = watch('user.title', '');

    // Render JSX using state variables and other variables
    return (
        <div className="row">
            <div className="col-lg-12 text-label-row mb-2">
                <b className="example-label">Details:</b>
            </div>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-1" >
                <div className={selectedTitle === 'Other' ? 'input-group flex-nowrap' : ''}>
                    <div className={selectedTitle === 'Other' ? 'flex-fill' : ''} >
                        <Controller
                            name="user.title"
                            control={control}
                            rules={{ required: true }}
                            defaultValue=''
                            render={({ field }) => (
                                <DropDownListComponent
                                    id="title"
                                    dataSource={['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other']}
                                    placeholder="Select a title"
                                    value={field.value}
                                    required 
                                    floatLabelType="Auto" 
                                    change={(args) => field.onChange(args.value)}
                                  />
                            )}
                        />
                        {errors.user && errors.user.title && <Error>{errors.user.title.message ? errors.user.title.message : "* Please select your title"}</Error>}
                    </div>

                    {selectedTitle === 'Other' &&
                        (
                        <div className="mx-2 flex-fill">
                            <Controller
                                name="user.otherTitle"
                                control={control}
                                defaultValue=''
                                rules={{ required: true, validate: (value) => bogusCheck(value) || '* Please enter a valid title' }}
                                render={({ field }) => (
                                    <TextBoxComponent type="text" placeholder="Other Title" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="honorific-prefix" />
                                )}
                            />
                            {errors.user && errors.user.otherTitle && <Error>{errors.user.otherTitle.message ? errors.user.otherTitle.message : "* Please enter your title"}</Error>}
                        </div>  
                    )}
                </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-1">
                <Controller
                    name="user.firstName"
                    control={control}
                    rules={{ required: true, validate: (value) => bogusCheck(value) || '* Please enter a valid first name' }}
                    defaultValue=''
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="First Name" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="given-name" />
                    )}
                />
                {errors.user && errors.user.firstName && <Error>{errors.user.firstName.message ? errors.user.firstName.message : "* Please enter your first name"}</Error>}
            </div>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-1">

                <Controller
                    name="user.lastName"
                    control={control}
                    rules={{ required: true, validate: (value) => bogusCheck(value) || '* Please enter a valid last name' }}
                    defaultValue=''
                    render={({ field }) => (
                        <TextBoxComponent type="text" placeholder="Last Name" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="family-name" />
                    )}
                />
                {errors.user && errors.user.lastName && <Error>{errors.user.lastName.message ? errors.user.lastName.message : "* Please enter your last name"}</Error>}
            </div>
            <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-1">

                <Controller
                    name="user.emailAddress"
                    control={control}
                    rules={{
                        required: true,
                        validate: (value) => (isEmail(value) && looksLikeEmail(value) && bogusCheck(value)) || '* Please enter a valid email address'
                    }}
                    defaultValue=''
                    render={({ field }) => (
                        <TextBoxComponent type="email" placeholder="Email Address" required floatLabelType="Auto" value={field.value} change={({ value }) => field.onChange(value.trim())} autocomplete="email" />
                    )}
                />

                {errors.user && errors.user.emailAddress && <Error>{errors.user.emailAddress.message ? errors.user.emailAddress.message : "* Please enter your email"}</Error>}
            </div>
        </div >
    );
};